class SwatchNavigation extends HTMLElement {
      constructor() {
        super();
        this.swatches = this.querySelectorAll('.swatch-navigation__link')
        //console.log(this.swatches)

        // Detect if device supports pointer events (such as mouse or touch)
        const supportsPointer = window.matchMedia('(pointer:fine)').matches;

        // If device supports pointer events, add mouse event listeners
        if (supportsPointer) {
          this.swatches.forEach((swatch) => {
            swatch.addEventListener('mouseenter', this.onSwatchMouseEnter.bind(this));
          });
        }
      }

      // Handles the summary element being entered with a pointer (mouse or touch)
      onSwatchMouseEnter(event) {
        console.log('onSwatchMouseEnter')

        event.currentTarget.addEventListener('mouseleave', this.onSwatchMouseLeave.bind(this));

        this.updateLegend(true, event.currentTarget)
      }

      // Handles the pointer leaving the header element
      onSwatchMouseLeave(event) {
        console.log('onSwatchMouseLeave')

        event.currentTarget.removeEventListener('mouseleave', this.onSwatchMouseLeave.bind(this));

        this.updateLegend(false)
      }

      updateLegend(reveal = false, swatch) {
        if(reveal){
          this.querySelector('.swatch-navigation__tooltip').innerHTML = swatch.dataset.tooltip;
          this.querySelector('.swatch-navigation__title').classList.add('active')
        }else{
          this.querySelector('.swatch-navigation__title').classList.remove('active')
        }
      }
    }


customElements.define('swatch-navigation', SwatchNavigation);